import { createSharingLink } from '../services/createSharingLink';
import CreateAttachmentSharingLinkResponse from 'owa-service/lib/contract/CreateAttachmentSharingLinkResponse';
import { orchestrator } from 'satcheljs';
import {
    createSharingLink as createSharingLinkAction,
    updateSharePointLinkUrl,
} from '../actions/internalActions';

orchestrator(createSharingLinkAction, async actionMessage => {
    const response: CreateAttachmentSharingLinkResponse = await createSharingLink(
        actionMessage.canonicalUrl,
        actionMessage.newPermissionLevel
    );

    updateSharePointLinkUrl(
        actionMessage.linkId,
        response.Link,
        actionMessage.currentUrl,
        response.ExpirationDate
    );
});
